import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            filter: '',
            fromDate: '',
            tabIndex: 0,
            toDate: '',
            companyName: '',
            isDateError : null,
            openAddOrder: false,
            drivers: [],
            companies: [],
            allAverageCompany: 0,
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.drivers.filter(item => {
                return  this.checkNull(item.username).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            })
        },

        filteredCompanies() {
            return this.companies.filter(item => {
                return this.checkNull(item.name).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            })
        }
    },
    methods: {
        getReport: getReport,
        round: round,
        setTab: setTab,
        getModuleStyle: getModuleStyle,
        calculateHours: calculateHours,
        displayHoursAndMinutes: displayHoursAndMinutes,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        keymonitor: keymonitor,
        checkNull: checkNull,
        openAddUserModal: openAddUserModal,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVehicle', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddVehicle', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodato vozilo', 'success')
            _self.getVehicles();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')

    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function changedDateFrom() {

}


function changedDateTo() {

}

function getReport() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    // swal('Molimo sačekajte', 'Kreiranje izveštaja', 'warning');
    _self.isDateError = null;
    var activeParams = "?status=DELIVERED";
    var date =  "&fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo;
    AdminApiService.getOrders(activeParams, date)
        .then((response) => {
            swal('Uspešno', 'Izveštaj uspešno kreiran', 'success');
            let map = new Map();
            let map2 = new Map();
            let rawData = response.data.filter(e =>  e.pickedUpTime !=null && e.deliveredTime != null);
            // let rawData2 = response.data.filter(e => e.pickedUpTime !=null && e.deliveredTime != null);
            for (let i = 0; i < rawData.length; i++) {
                //map by courier
                if(rawData[i].courier != null){
                    if(map.get(rawData[i].courier.username) == null){
                        var newModel = {
                            username: rawData[i].courier.username,
                            firstName: rawData[i].courier.firstName,
                            count: 1,
                            average: (rawData[i].deliveredTime - rawData[i].pickedUpTime)/60000
                        }
                        map.set(rawData[i].courier.username, newModel);
                    }else{
                        let oldValue = map.get(rawData[i].courier.username);
                        oldValue.count = oldValue.count + 1;
                        oldValue.average = oldValue.average + ((rawData[i].deliveredTime - rawData[i].pickedUpTime)/60000);
                        map.set(rawData[i].courier.username, oldValue);
                    }
                }
                //map by company
                if(map2.get(rawData[i].company.id) == null){
                    var newModel2 = {
                        name: rawData[i].company.name,
                        count: 1,
                        average: (rawData[i].deliveredTime - rawData[i].pickedUpTime)/60000
                    }
                    map2.set(rawData[i].company.id, newModel2);
                }else{
                    let oldValue = map2.get(rawData[i].company.id);
                    oldValue.count = oldValue.count + 1;
                    oldValue.average = oldValue.average + ((rawData[i].deliveredTime - rawData[i].pickedUpTime)/60000);
                    map2.set(rawData[i].company.id, oldValue);
                }


            }
            // console.log(Array.from( map.values() ));
            // console.log(Array.from( map2.values() ));

            _self.drivers = Array.from( map.values() );
            _self.companies = Array.from( map2.values() );
            var average = 0;
            for (let i = 0; i <  _self.companies.length; i++) {
                average = average + Math.round(_self.companies[i].average / _self.companies[i].count);
            }
            _self.allAverageCompany = Math.round(average / _self.companies.length);

        })
        .catch((error) => {
            // console.log(error);
            swal('Greška', error.message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}


function checkNull(data) {
    if(data == null) return 0;
    return data;
}


function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100
}


function calculateHours(schedule) {
    if(schedule.startTime == null || schedule.completionTime == null) return 0;
    var minutes = (schedule.completionTime - schedule.startTime)/60000;
    return Math.floor(minutes)
}

function displayHoursAndMinutes(minutes) {
    var hours = Math.floor(minutes / 60);
    var minutes = minutes % 60;
    return "" + hours + " H "+minutes +" min"
}

function setTab(index) {
    this.tabIndex = index;
}

function getModuleStyle(index) {
    if(index === this.tabIndex){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: #1b1e24; color: white;"
    }
}


// WEBPACK FOOTER //
// ./src/components/Report/AverageReport.js